import { useEffect, useRef } from 'react';
import { useDomain } from '../context/DomainContext';

/**
 * Carga dinámicamente el script de cookies según la config del dominio.
 * Soporta:
 * - Lawwwing: data-lwid
 * - legal-pmoz: data-id
 */
const CookieScript = () => {
  const { cookieScriptUrl, cookieScriptLwid, cookieScriptDataId } = useDomain();
  const loadedRef = useRef(false);

  useEffect(() => {
    const hasLwid = cookieScriptLwid && cookieScriptLwid.trim();
    const hasDataId = cookieScriptDataId && cookieScriptDataId.trim();
    const hasId = hasLwid || hasDataId;

    if (!cookieScriptUrl || !hasId || loadedRef.current) return;

    const attr = hasLwid ? 'data-lwid' : 'data-id';
    const value = hasLwid ? cookieScriptLwid : cookieScriptDataId;
    const existing = document.querySelector(`script[${attr}="${value}"]`);
    if (existing) return;

    const script = document.createElement('script');
    script.src = cookieScriptUrl;
    script.type = 'text/javascript';
    script.setAttribute(attr, value);
    script.async = true;
    document.head.appendChild(script);
    loadedRef.current = true;
  }, [cookieScriptUrl, cookieScriptLwid, cookieScriptDataId]);

  return null;
};

export default CookieScript;
